import { Laptop, Moon, Sun } from "lucide-react";
import { useThemeStore, type ThemeMode } from "@/stores/theme";
import { cn } from "@/lib/utils";

// Three-way segmented control: 浅色 / 跟随系统 / 深色.
// Keeps the active mode highlighted so the user can see whether the current
// "system" choice means light or dark would be irrelevant — they explicitly
// asked for system, that's what's shown.

const OPTIONS: { mode: ThemeMode; label: string; Icon: typeof Sun }[] = [
  { mode: "light", label: "浅色", Icon: Sun },
  { mode: "system", label: "跟随系统", Icon: Laptop },
  { mode: "dark", label: "深色", Icon: Moon },
];

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);

  return (
    <div
      role="radiogroup"
      aria-label="主题模式"
      className="inline-flex items-center gap-0.5 rounded-full border border-border bg-input p-0.5"
    >
      {OPTIONS.map(({ mode: m, label, Icon }) => {
        const active = mode === m;
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={label}
            onClick={() => setMode(m)}
            className={cn(
              "inline-flex h-7 items-center gap-1 rounded-full px-2 text-xs transition-colors",
              active
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {!compact && <span>{label}</span>}
          </button>
        );
      })}
    </div>
  );
}
